// extracted by mini-css-extract-plugin
export default {"products-table":"ProductsTable_products-table__hP3yx","tooltip":"ProductsTable_tooltip__Z2-bx"};